export default __webpack_public_path__ + "static/media/login.8cc1ab77.svg";